import { Token } from 'config/types'
import Column from 'layout/Components/Column'
import React from 'react'
import BetAmountTrigger from 'views/InhouseGame/components/Controls/BetAmountTrigger'
import InhouseTokenAmoutInput from 'views/InhouseGame/components/Controls/InhouseTokenAmoutInput'
import { AutoBetConfiguration } from '../config/autobet'

const AutoBetConditionConfig: React.FC<{
  config?: AutoBetConfiguration
  disabled?: boolean
  isRunning: boolean
  betToken: Token
  updateConfig: (key: keyof AutoBetConfiguration, value: AutoBetConfiguration[typeof key]) => void
}> = ({ updateConfig, disabled, isRunning, betToken, config, ...props }) => {
  return (
    <Column {...props}>
      <BetAmountTrigger
        mb="12px"
        disabled={disabled || isRunning}
        config={config.winBetConfig}
        label="On Win"
        setConfig={(config) => {
          updateConfig('winBetConfig', config)
        }}
      />
      <BetAmountTrigger
        mb="12px"
        disabled={disabled || isRunning}
        config={config.lossBetConfig}
        label="On Loss"
        setConfig={(config) => {
          updateConfig('lossBetConfig', config)
        }}
      />

      <InhouseTokenAmoutInput
        betToken={betToken}
        mb="12px"
        disabled={disabled || isRunning}
        value={config.takeProfit}
        label="Stop on Profit"
        setValue={(value) => {
          updateConfig('takeProfit', value)
        }}
      />

      <InhouseTokenAmoutInput
        betToken={betToken}
        mb="24px"
        disabled={disabled || isRunning}
        value={config.stopLoss}
        label="Stop on Loss"
        setValue={(value) => {
          updateConfig('stopLoss', value)
        }}
      />
    </Column>
  )
}

export default AutoBetConditionConfig
